import {connect} from 'react-redux';
import BreadcrumbsComponent from './BreadCrumbs.js';

export function mapStateToProps(state) {
    return {
        theme: state.siteContext.theme,
        breadcrumbs: state.modules.breadcrumbs,
        isRefined: state.config.isRefined,
    };
}

const BreadCrumbs = connect(mapStateToProps)(BreadcrumbsComponent);
BreadCrumbs.displayName = 'BreadCrumbs';

export default BreadCrumbs;
